/* ============================================================
   IGNITE — V600 PRODUCT BLOCK (v3, debuguit)

   FIX-uri fata de v2:
   - Replacement-ul se insereaza ACUM IN INTERIORUL formularului,
     deci guard-ul "exista deja?" functioneaza -> NU se mai
     multiplica la infinit.
   - Dedup pe sectiune (shopify-section) + se sare peste formularele
     duplicate Focal (product-form__buy-buttons) -> exact 2 butoane.
   - Redirect intarit: preventDefault + stopPropagation + redirect.

   Rezultat pe pagina V600: ascunde "Adaugă în coș" / "Cumpără acum"
   si pune EXACT 2 butoane, AMBELE duc pe homepage ('/'):
     1) "Produs promoțional"
     2) "Vezi promoția"
   Detectie STRICTA dupa variant ID (input[name="id"]).
   ============================================================ */

(function () {
  'use strict';

  var V600_VARIANT_IDS = [
    '46754223653193', // Banana Ice
    '46754223685961', // Blueberry Ice
    '46754223718729', // Strawberry Guava Ice
    '46754223751497', // Watermelon Ice
    '46754223784265'  // Mango Ice
  ];

  var HOME_URL  = '/';
  var BTN1_TEXT = 'Produs promoțional';
  var BTN2_TEXT = 'Vezi promoția';
  var REPL_ATTR = 'data-v600-replacement';

  function log() {
    try {
      if (window.__igniteDebug) {
        console.log.apply(console, ['[V600-BLOCK v3]'].concat([].slice.call(arguments)));
      }
    } catch (e) {}
  }

  function injectStyles() {
    if (document.getElementById('v600-promo-block-styles')) return;
    var css =
      '.v600-promo-replacement{display:flex;flex-direction:column;gap:12px;margin-top:10px;width:100%;}' +
      '.v600-promo-btn{display:flex;align-items:center;justify-content:center;' +
        'padding:15px 18px;border-radius:10px;font-weight:700;text-transform:uppercase;' +
        'letter-spacing:.05em;text-decoration:none;font-size:.9rem;cursor:pointer;' +
        'border:1px solid #efaf01;transition:filter .2s ease,transform .15s ease;}' +
      '.v600-promo-btn--ghost{background:linear-gradient(90deg,rgba(239,175,1,.12),rgba(239,175,1,.02));' +
        'color:#efaf01;}' +
      '.v600-promo-btn--solid{background:#efaf01;color:#0a0a0a;}' +
      '.v600-promo-btn:hover{filter:brightness(1.08);transform:translateY(-1px);}' +
      '.v600-promo-btn--solid:hover{color:#0a0a0a;}' +
      '.v600-promo-btn--ghost:hover{color:#efaf01;}' +
      '.v600-promo-btn:active{transform:translateY(0);}';
    var s = document.createElement('style');
    s.id = 'v600-promo-block-styles';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function isV600Form(form) {
    try {
      var idInput = form.querySelector('input[name="id"]');
      if (idInput && idInput.value &&
          V600_VARIANT_IDS.indexOf(String(idInput.value).trim()) !== -1) {
        return true;
      }
    } catch (e) {}
    return false;
  }

  function makeBtn(text, variant) {
    var a = document.createElement('a');
    a.className = 'v600-promo-btn ' + variant;
    a.href = HOME_URL;
    a.setAttribute('role', 'button');
    a.textContent = text;
    a.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = HOME_URL;
    }, false);
    return a;
  }

  function buildReplacement() {
    var wrap = document.createElement('div');
    wrap.className = 'v600-promo-replacement';
    wrap.setAttribute(REPL_ATTR, 'true');
    wrap.appendChild(makeBtn(BTN1_TEXT, 'v600-promo-btn--ghost'));
    wrap.appendChild(makeBtn(BTN2_TEXT, 'v600-promo-btn--solid'));
    return wrap;
  }

  function hideBuyButtons(form) {
    form.querySelectorAll(
      'button[type="submit"], [name="add"], .product-form__submit, ' +
      '.product-form__buy-buttons, .shopify-payment-button, ' +
      '.shopify-payment-button__button, .product-form__payment-container button'
    ).forEach(function (b) {
      try { b.style.setProperty('display', 'none', 'important'); } catch (e) {}
    });
  }

  function process() {
    injectStyles();

    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    var seenSections = {};

    forms.forEach(function (form) {
      if (!isV600Form(form)) return;

      // ascunde butoanele standard pe ORICE form V600
      hideBuyButtons(form);

      // sare peste formularele duplicate Focal (doar payment buttons)
      var parentClass = (form.parentElement && form.parentElement.className) || '';
      if (parentClass.indexOf('product-form__buy-buttons') !== -1) {
        log('skip form duplicat (buy-buttons)');
        return;
      }

      // un singur replacement per sectiune
      var section = form.closest('[id^="shopify-section-"]');
      var key = section ? section.id : 'page-product';
      if (seenSections[key]) return;
      seenSections[key] = true;

      // daca formularul are deja replacement INAUNTRU -> nu mai adauga
      if (form.querySelector('[' + REPL_ATTR + '="true"]')) return;

      var anchor = form.querySelector(
        '.product-form__buttons, .product-form__payment-container, .product-form__submit'
      );
      var rep = buildReplacement();
      try {
        if (anchor && anchor.parentNode && form.contains(anchor)) {
          anchor.parentNode.insertBefore(rep, anchor.nextSibling); // ramane IN form
        } else {
          form.appendChild(rep); // IN form
        }
      } catch (e) {
        form.appendChild(rep);
      }
      log('replacement inserat in sectiunea', key);
    });
  }

  function init() {
    process();

    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      setTimeout(function () { scheduled = false; process(); }, 80);
    }

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) { schedule(); return; }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('change', function (e) {
      if (e.target && (e.target.name === 'id' ||
          (e.target.closest && e.target.closest('form[action*="/cart/add"]')))) {
        schedule();
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();